<script lang="ts" setup>
import { ref, nextTick, inject } from "vue"; 
import { useForm, } from "@/helpers/composables/useForm";
import { route } from "ziggy-js";
import { object, string } from "yup";
import RothcoCta from "@/components/RothcoCta.vue";
import PasswordInput from "@/components/PasswordInput.vue";
let route = inject('route');
let props = defineProps({
    user: {
        type: Object,
        default(){
            return {}
        }
    },
    encryption: {
        type: String,
        default: ''
    }
});
let resetPasswordForm = useForm({
    useInertia: true,
    schema: object({
        password: string().required('The password field is required').min(8, 'Password must be at least 8 characters').test('uppercase', 'Password must contain at least one uppercase letter', (value) => {
                return /[A-Z]/.test(value);
            }).test('lowercase', 'Password must contain at least one lowercase letter', (value) => {
                return /[a-z]/.test(value);
            }).test('number', 'Password must contain at least one number', (value) => {
                return /[0-9]/.test(value);
            }).test('special', 'Password must contain at least one special character (# ? ! @ $  % ^ & * -)', (value) => {
                return /[#?!@$%^&*-]/.test(value);
            }).test('spaces', 'Password must not contain spaces', (value) => {
                return !/\s/.test(value);
            }).test('weak', 'Password is too weak', (value) => {
                return !/password/i.test(value);
            }).default(""),
        password_confirmation: string().required('Password confirmation is required').test({
                name: "password_confirmation",
                message: "Password confirmation does not match",
                test: (value) => {
                    return value == resetPasswordForm.password;
                }
        }).default(''),
        encryption: string().required().default(props.encryption)
    }),
});

const resetPassword = async ()=>{
    if(resetPasswordForm.processing) return;

    await resetPasswordForm.validate();
    nextTick(()=>{
        if(Object.keys(resetPasswordForm.errors).length == 0){
            resetPasswordForm.post(route('web.change-password'));
        }
    })
}
</script>
<template>
    <div class="authorization">
    <form class="authorization-form forgot-password-form" @submit.prevent="resetPassword()">
        <div class="authorization_popup-title headline-m" >Reset Password</div>
        <PasswordInput 
            v-model="resetPasswordForm.password" 
            :errors="resetPasswordForm.errors.password" 
            id="email_password_register"
        />
        <PasswordInput 
            v-model="resetPasswordForm.password_confirmation" 
            :errors="resetPasswordForm.errors.password_confirmation" 
            id="confirm_email_password_register"
            placeholder="Confirm Password"
        />
        <RothcoCta id="resetPasswordBtn" type="submit" :disabled="resetPasswordForm.processing" ctaType="button" class="primary">
            Reset Password
        </RothcoCta>
    </form>
</div>
</template>